import { render, staticRenderFns } from "./TenantEditVerificationChallenges.vue?vue&type=template&id=6fdb5da2&scoped=true&"
import script from "./TenantEditVerificationChallenges.vue?vue&type=script&lang=js&"
export * from "./TenantEditVerificationChallenges.vue?vue&type=script&lang=js&"
import style0 from "./TenantEditVerificationChallenges.vue?vue&type=style&index=0&id=6fdb5da2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fdb5da2",
  null
  
)

export default component.exports